export default __webpack_public_path__ + "static/media/fun4kids.fc46243a.png";